// Translations
import accessKeyManagingDialog from '../components/access-key-managing-dialog/translations/en'

// Translation: Model > Access key manager (English)
export default Object.freeze({
	actions: {
		create: {
			hint: 'You cannot create more than {{limit}} access keys',
			text: 'Create an access key'
		}
	},
	components: { accessKeyManagingDialog }
})
